import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Adjust path if needed

const TicketOrigin = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [ticketOrigins, setTicketOrigins] = useState([
    { origin: "Local", status: "Active", id: 1 },
    { origin: "Foreign", status: "Inactive", id: 2 },
    { origin: "SAARC", status: "Active", id: 3 },
    { origin: "Non-SAARC", status: "Inactive", id: 4 },
  ]);

  const [formData, setFormData] = useState({
    origin: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [ticketOrigins]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedOrigin) {
      setTicketOrigins(
        ticketOrigins.map((o) =>
          o.id === selectedOrigin.id ? { ...formData, id: o.id } : o
        )
      );
    } else {
      setTicketOrigins([
        ...ticketOrigins,
        {
          ...formData,
          id: ticketOrigins.length ? ticketOrigins[ticketOrigins.length - 1].id + 1 : 1,
        },
      ]);
    }
    setShowForm(false);
    setFormData({ origin: "", status: "Active" });
    setSelectedOrigin(null);
  };

  const handleEdit = (origin) => {
    setSelectedOrigin(origin);
    setFormData({
      origin: origin.origin,
      status: origin.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedOrigin(null);
    setFormData({ origin: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="ticket-origin d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedOrigin ? "Edit Ticket Origin" : "Add Ticket Origin"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Origin:</label>
              <input
                type="text"
                name="origin"
                value={formData.origin}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Ticket Origins</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Ticket Origin
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Origin</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ticketOrigins.map((origin) => (
                  <tr key={origin.id}>
                    <td>{origin.origin}</td>
                    <td>
                      <span
                        className={`badge ${
                          origin.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {origin.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(origin)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketOrigin;
